import {
  FETCH_APIKEYS,
  FETCH_APIKEY,
  CREATE_APIKEY,
  UPDATE_APIKEY,
  DEACTIVATE_APIKEY,
  DELETE_APIKEY,
  APIKEY_ERROR,
  CLEAR_APIKEY_ERROR
} from "./types";

const API_URL = "/api/admin/apikeys";

function handleResponse(response) {
  if (response.ok) {
    return response.json();
  } else {
    let error = new Error(response.statusText);
    error.response = response.statusText;
    throw error;
  }
}

// Clear error
export const clearApiKeyError = () => ({
  type: CLEAR_APIKEY_ERROR
});

// Haal alle API keys op
export const fetchApiKeys = () => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(API_URL, {
      method: 'GET',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: FETCH_APIKEYS,
      payload: data.results
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: APIKEY_ERROR,
      payload: error.message || "Fout bij ophalen API keys"
    });
    
    return { type: "APIKEY_ERROR", error: error.message };
  }
};

// Haal specifieke API key op
export const fetchApiKey = (id) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${API_URL}/${id}`, {
      method: 'GET',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: FETCH_APIKEY,
      payload: data.result
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: APIKEY_ERROR,
      payload: error.message || "Fout bij ophalen API key"
    });
    
    return { type: "APIKEY_ERROR", error: error.message };
  }
};

// Maak nieuwe API key aan
export const createApiKey = (apiKeyData) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(apiKeyData)
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: CREATE_APIKEY,
      payload: data.result
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: APIKEY_ERROR,
      payload: error.message || "Fout bij aanmaken API key"
    });
    
    return { type: "APIKEY_ERROR", error: error.message };
  }
};

// Update API key
export const updateApiKey = (id, apiKeyData) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${API_URL}/${id}`, {
      method: 'PUT',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(apiKeyData)
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: UPDATE_APIKEY,
      payload: data.result
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: APIKEY_ERROR,
      payload: error.message || "Fout bij bijwerken API key"
    });
    
    return { type: "APIKEY_ERROR", error: error.message };
  }
};

// Deactiveer API key
export const deactivateApiKey = (id) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${API_URL}/${id}/deactivate`, {
      method: 'PUT',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: DEACTIVATE_APIKEY,
      payload: data.result
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: APIKEY_ERROR,
      payload: error.message || "Fout bij deactiveren API key"
    });
    
    return { type: "APIKEY_ERROR", error: error.message };
  }
};

// Verwijder API key
export const deleteApiKey = (id) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${API_URL}/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json'
      }
    });
    
    const data = await handleResponse(response);
    
    dispatch({
      type: DELETE_APIKEY,
      payload: id
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: APIKEY_ERROR,
      payload: error.message || "Fout bij verwijderen API key"
    });
    
    return { type: "APIKEY_ERROR", error: error.message };
  }
};